module.exports = __webpack_public_path__ + "static/media/clock.c3a65cb6.svg";